export function appScreen(state = 'main', action) {
    switch (action.type) {
        case 'APP_SCREEN':
            return action.appScreen;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/lib/redux/reducers/app.js